import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { NewHireCreate } from '../../modules/NewHire/components/NewHireCreate';
import { newHireDashboardCheck } from '../../tools/permissionChecks';

export const Route = createFileRoute('/hrDashboard/newHire/create')({
  component: RouteComponent,
  loader(ctx) {
    const permissionCheck = newHireDashboardCheck(ctx.context.authContext.user);
    if (!permissionCheck) {
      toast({
        title: 'Access Denied',
        description:
          'You do not have permission to create new hires. Please contact your administrator if you believe this is an error.',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  head() {
    return {
      meta: [{ title: 'HR Dashboard - New Hire' }],
    };
  },
});

function RouteComponent() {
  return <NewHireCreate />;
}
